export enum RequisitesType {
  bank = "bank-requisite",
  crypto = "crypto-requisite",
}

export enum RequisitesWalletType {
  new = "new",
  pattern = "pattern",
}
